import React from "react";
import * as autoBind from "auto-bind";
import withUserData from "./withUserData";
import getAccessLevel from "../lib/access/getAccessLevel";
import { showModal } from "../lib/react-redux-modal-provider";

export default function withHistoryListItemAccessHandler(WrappedComponent) {
  @withUserData
  class WithHistoryListItemAccessHandler extends React.Component {
    constructor(props) {
      super(props);

      autoBind.react(this);
    }

    handleDescriptionButtonClick(callback, shouldCheckAccess, permissions) {
      const { hasPermission } = this.props;

      if (shouldCheckAccess) {
        const hasAccess = hasPermission(permissions);
        if (!hasAccess) {
          showModal("PremiumModal", {
            skipShowIfAlreadyVisible: true,
            permissions
          });
        }

        callback(hasAccess);
      } else {
        callback(true);
      }
    }

    getAccessLevel() {
      const { userData } = this.props;

      return getAccessLevel(userData, {});
    }

    render() {
      const accessLevel = this.getAccessLevel();

      return (
        <WrappedComponent
          {...this.props}
          accessLevel={accessLevel}
          handleDescriptionButtonClick={this.handleDescriptionButtonClick}
        />
      );
    }
  }

  return WithHistoryListItemAccessHandler;
}
